import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/app/src/app/services/microsoft-fabric-beratung/components/FabricBeratungClient.tsx");
;
import(/* webpackMode: "eager" */ "/usr/app/src/assets/styles/pages.scss");
